/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateUserMobilityDto
 */
export interface CreateUserMobilityDto {

    /**
     * @type {Date}
     * @memberof CreateUserMobilityDto
     */
    date: Date;

    /**
     * @type {number}
     * @memberof CreateUserMobilityDto
     */
    value?: number | null;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateUserMobilityDto
     */
    mobility: JoinEntityDto;

    /**
     * @type {string}
     * @memberof CreateUserMobilityDto
     */
    note?: string | null;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateUserMobilityDto
     */
    user?: JoinEntityDto | null;
}
